import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@grapecity/wijmo.styles/wijmo.css';
import '@css/common-page.css';
import './App.css';
import { Outlet, Route, Routes } from "react-router-dom";
import CompanyLogIn from '@features/Auth/CompanyLogIn';
import Login from '@features/Auth/LogIn';
import ErrorAlert from '@components/ErrorAlert';
import SideBarLayout from '@features/Sidebar/SideBarLayout';
import ProtectedRoute from './ProtectedRoute'
import Header from '@components/Header';
import MainView from '@features/TabSystem/MainView';
import NotFound from './NotFound';
import GlobalSpinner from './GlobalSpinner';
import axiosInstance from '@utils/axiosInstance';

function Layout({ envName }) {
  const [showModal, setShowModal] = useState(false);
  const [companies, setCompanies] = useState([]);

  const getCompanyList = async () => {
    try {
      const response = await axiosInstance.get('/api/companies/getList');
      setCompanies(response.data);
      setShowModal(true);
    }catch(error){
       console.log(error);
    }
    
  };

  return (
    <div className="layout-container" style={{
      display: 'flex',
      width: '100%',
      minHeight: '100vh',
      alignItems: 'stretch'
    }}>
      <SideBarLayout />
      <div className="main-content" style={{
        width: '85%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        flex: 1
      }}>
        <Header onClickCompanySelect={() => getCompanyList()} envName={envName} />
        <Outlet context={{ showModal, setShowModal, companies, setCompanies }} />
      </div>
    </div>
  );
}

function App() {
  const [envName, setEnvName] = useState('');

  useEffect(() => {
    axiosInstance.get('/api/env')
      .then(res => setEnvName(res.data))
      .catch(() => setEnvName(''));
  }, []);

  return (
    <>
        <GlobalSpinner />
        <Routes>
          <Route index element={<CompanyLogIn />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Layout envName={envName} /></ProtectedRoute>}>
            <Route path='main' element={<MainView />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ErrorAlert />
      </>
  );
}

export default App;
